<template>
  <v-card class="mb-4">
    <v-card-text>
      <span class="date-display ">
        {{
          $t('reports_ui.weekly_scorecard_report.date_format', {
            'weekDate' : weekDate.format('LL'),
            'weekNumber': weekDate.format('w')
          })
        }}
      </span>
      <v-simple-table class="mt-3">
        <thead>
        <tr>
          <th class="divider"></th>
          <th colspan="5" class="text-center divider">
            <span class="table-header">{{ $t('reports_ui.weekly_scorecard_report.routes_in_spec')}}</span>
          </th>
          <th colspan="5" class="text-center divider">
            <span class="table-header">{{ $t('reports_ui.weekly_scorecard_report.linked_plans')}}</span>
          </th>
          <th colspan="5" class="text-center divider">
            <span class="table-header">{{ $t('reports_ui.weekly_scorecard_report.completed_root_causes')}}</span>
          </th>
        </tr>
        <tr>
          <th class="divider">DC</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.previous_week') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.current_week') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.previous_month') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.current_month') }}</th>
          <th class="divider">{{ $t('reports_ui.weekly_scorecard_report.ytd') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.previous_week') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.current_week') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.previous_month') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.current_month') }}</th>
          <th class="divider">{{ $t('reports_ui.weekly_scorecard_report.ytd') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.previous_week') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.current_week') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.previous_month') }}</th>
          <th>{{ $t('reports_ui.weekly_scorecard_report.current_month') }}</th>
          <th class="divider">{{ $t('reports_ui.weekly_scorecard_report.ytd') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(customer, customerId) in report.results" :key="customerId">
          <td class="divider">{{ customer.name }}</td>

          <!-- Percent Routes in Spec -->
          <td>{{ customer.data.compareWeek.percent_routes_in_spec }}%</td>
          <td :class="getTargetClass(routeTarget, customer.data.week.percent_routes_in_spec)">
            {{ customer.data.week.percent_routes_in_spec }}%
          </td>
          <td>{{ customer.data.compareMonth.percent_routes_in_spec }}%</td>
          <td :class="getTargetClass(routeTarget, customer.data.month.percent_routes_in_spec)">
            {{ customer.data.month.percent_routes_in_spec }}%
          </td>
          <td class="divider">{{ customer.data.year.percent_routes_in_spec }}%</td>
          <td>{{ customer.data.compareWeek.percent_route_plans_linked }}%</td>

          <!-- Percent Route Plans Linked -->
          <td :class="getTargetClass(planTarget, customer.data.week.percent_route_plans_linked)">
            {{ customer.data.week.percent_route_plans_linked }}%
          </td>
          <td>{{ customer.data.compareMonth.percent_route_plans_linked }}%</td>
          <td :class="getTargetClass(planTarget, customer.data.month.percent_route_plans_linked)">
            {{ customer.data.month.percent_route_plans_linked }}%
          </td>
          <td class="divider">{{ customer.data.year.percent_route_plans_linked }}%</td>

          <!-- Percent Root Causes Assessed -->
          <td>{{ customer.data.compareWeek.percent_root_causes_assessed }}%</td>
          <td :class="getTargetClass(completionTarget, customer.data.week.percent_root_causes_assessed)">
            {{ customer.data.week.percent_root_causes_assessed }}%
          </td>
          <td>{{ customer.data.compareMonth.percent_root_causes_assessed }}%</td>
          <td :class="getTargetClass(completionTarget, customer.data.month.percent_root_causes_assessed)">
            {{ customer.data.month.percent_root_causes_assessed }}%
          </td>
          <td class="divider">{{ customer.data.year.percent_root_causes_assessed }}%</td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ReportRecord from '@/orm/models/ReportRecord'
import Moment from 'moment'

export default {
  name: 'WeeklyScorecardReport',
  props: {
    report: {
      type: ReportRecord
    }
  },
  data () {
    return {
    }
  },
  computed: {
    weekDate () {
      return Moment(this.report.parameters.weekDate)
    },
    routeTarget () {
      return this.report.parameters.routeTarget
    },
    planTarget () {
      return this.report.parameters.planTarget
    },
    completionTarget () {
      return this.report.parameters.completionTarget
    }
  },
  methods: {
    getTargetClass (target, current) {
      return current < target ? 'text-danger' : 'text-success'
    }
  }
}
</script>

<style scoped lang="scss">
.table-header {
  font-size: 16px;
}
.divider {
  border-right: 1px solid #efefef;
}
.date-display {
  font-size: 18px;
}
</style>
